import * as React from 'react';
import { CenterModal, ButtonWithIcon, Typography } from 'components';
import styled from 'styled-components';
import {
  VEHICLE_PREFERENCE_INFO,
} from 'constants/vehiclePreference';

interface VehicleModalProps {
  closeModal: () => void;
  onVehicleClick: (vehicle: string) => void;
  selectedVehicle: string;
  disabled?: boolean;
}

class VehicleModal extends React.Component<VehicleModalProps> {
  render(): React.ReactNode {
    const vehicleList = [];
    for (const [key, value] of Object.entries(VEHICLE_PREFERENCE_INFO)) {
      value.isShown &&
        vehicleList.push({
          key: key,
          description: value.description,
          dimension: value.dimension,
          capacity: value.capacity,
        });
    }
    return (
      <CenterModal
        title="Select your vehicle"
        closeButtonOnClick={this.props.closeModal}
        width="medium"
        position="bottom"
      >
        <VehiclesContainer>
          {vehicleList.map((vehicle) => (
            <ButtonWithIcon
              key={vehicle.key}
              icon={
                <VehicleIcon
                  src={VEHICLE_PREFERENCE_INFO[vehicle.key].icon}
                />
              }
              isActive={this.props.selectedVehicle === vehicle.key}
              disabled={this.props.disabled && this.props.selectedVehicle !== vehicle.key}
              mainText={<Typography
                as="span"
                color="gray_700"
                weight="semibold"
                size="md"
                customStyle={{ marginRight: 'auto' }}
              >
                {vehicle.description}
              </Typography>}
              description={<Typography
                as="h1"
                color="gray_600"
                weight="normal"
                size="sm"
                customStyle={{ marginRight: 'auto', textAlign: 'left' }}
              >
                {vehicle.capacity}
              </Typography>}
              onClick={(): void => {
                this.props.onVehicleClick(vehicle.key);
                this.props.closeModal();
              }}
            />
          ))}
        </VehiclesContainer>
      </CenterModal>
    );
  }
}

const VehiclesContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 1rem;
  margin-top: 1rem;
  width: 100%;

  @media (min-width: 650px) {
    grid-template-columns: 1fr;
  }

  @media (min-width: 918px) {
    grid-template-columns: 1fr 1fr;
  }
`;

const VehicleIcon = styled.img`
  width: 5rem;
  height: 2rem;
`;

export default VehicleModal;
